import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../util/types";
import { hostThemes } from "../../theme/hostThemes";

export const commonContainer = (theme: ThemeV2, isSelf: boolean): SxProps => ({
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  margin: `${theme.tokens.spacing["2"]}px 0`,
  justifyContent: isSelf ? "flex-end" : "flex-start",
});

export const commonWrapper = (
  theme: ThemeV2,
  isSelf: boolean,
  timerImageOPen: boolean,
): SxProps => {
  const primaryColor = theme.tokens.color.action.primary;
  const bubble = hostThemes.chat.bubble;

  return {
    paddingBlock: `${theme.tokens.spacing["2"]}px`,
    paddingInline: `${theme.tokens.spacing["4"]}px`,
    position: "relative",
    filter: `drop-shadow(${theme.tokens.elevation["message-shadow"]})`,
    opacity: timerImageOPen ? "0.1" : "1",
    backgroundColor: isSelf ? primaryColor : theme.tokens.color.surface.card,
    borderRadius: `${bubble.cornerRadius}px`,
    maxWidth: isSelf ? "100%" : bubble.incomingMaxWidth,
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: `-${bubble.tailBottomOffset}px`,
      [isSelf ? "right" : "left"]: 0,
      width: `${bubble.tailSize}px`,
      height: `${bubble.tailSize}px`,
      backgroundColor: isSelf ? primaryColor : theme.tokens.color.surface.card,
      clipPath: 'path("M0 0 H18 V8 C18 15 20 20 24 24 C12 21 5 16 0 11 Z")',
      transform: isSelf ? undefined : "scaleX(-1)",
    },
  };
};
